module.exports = __webpack_public_path__ + "static/media/trombone-hadestown.24ef0e03.jpg";